import { gql } from "@apollo/client";

export const PROCESS_DOCUMENT_REPOSITORY = gql`
  mutation processDocumentRepository($params: ProcessDocumentRepositoryInput!) {
    processDocumentRepository(params: $params) {
      documentIds
    }
  }
`;
